"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const index_1 = require("../index");
const KeyValueColumnLinkDialog_1 = tslib_1.__importDefault(require("./KeyValueColumnLinkDialog"));
class KeyValueColumnWithLinks extends fmko_ts_common_1.Widget {
    constructor(args) {
        super();
        this.element = document.createElement("div");
        this.element.classList.add("key-value-column");
        const { moduleContext, header, data, striped } = args;
        this.element.classList.toggle("key-value-column-striped", !!striped);
        this.moduleContext = moduleContext;
        this.header = document.createElement("h2");
        this.header.classList.add("key-value-column-header", "h3");
        this.setHeader(header);
        this.add(this.header);
        this.dataContainer = new index_1.Div();
        this.dataContainer.addCssClass("key-value-column-data-container");
        this.setData(data);
        this.add(this.dataContainer);
    }
    setHeader(header) {
        this.header.textContent = header || "";
    }
    setHeaderVisible(visible) {
        this.headerVisible = visible;
        this.updateHeaderVisibility();
    }
    async setData(data) {
        this.dataContainer.clearHTMLChildren();
        if (!data) {
            return;
        }
        for (const { key, value } of data) {
            this.addKeyValueDataRow({ key, value });
        }
    }
    async addKeyValueDataRow(row) {
        const { key, value } = row;
        const div = document.createElement("div");
        div.classList.add("key-value-column-data-row");
        const label = document.createElement("label");
        label.textContent = key;
        label.classList.add("key-value-column-key");
        div.appendChild(label);
        this.dataContainer.add(div);
        const span = document.createElement("span");
        span.textContent = "Henter data...";
        span.classList.add("key-value-column-value");
        span.setAttribute(fmko_ts_common_1.ARIA.LABELLED_BY, label.id);
        div.appendChild(span);
        try {
            const valueAwaited = await value;
            if (!this.isKeyValueLink(valueAwaited) || !this.moduleContext) {
                const valueAwaitedString = valueAwaited?.toString() || "-";
                const valueAwaitedStringCapitalized = fmko_ts_common_1.StringUtils.firstToUpper(valueAwaitedString);
                span.textContent = valueAwaitedStringCapitalized;
                return;
            }
            const button = document.createElement("button");
            button.classList.add("anchor-button");
            button.textContent = valueAwaited.label;
            button.addEventListener("click", async () => {
                const dialog = new KeyValueColumnLinkDialog_1.default({
                    header: key,
                    keyValueColumnData: valueAwaited.data,
                    striped: true
                });
                await this.moduleContext.showDialog(dialog, {
                    title: key
                });
            });
            button.setAttribute(fmko_ts_common_1.ARIA.LABELLED_BY, label.id);
            div.removeChild(span);
            div.appendChild(button);
        }
        catch (e) {
            span.textContent = "Det fejlede at hente data!";
        }
    }
    updateHeaderVisibility() {
        (0, fmko_ts_common_1.setElementVisible)(this.header, this.headerVisible);
    }
    isKeyValueLink(value) {
        const keyValueColumnLinkType = value;
        if (!keyValueColumnLinkType) {
            return false;
        }
        if (!keyValueColumnLinkType.label) {
            return false;
        }
        if (!keyValueColumnLinkType.data) {
            return false;
        }
        return true;
    }
}
exports.default = KeyValueColumnWithLinks;
//# sourceMappingURL=KeyValueColumnWithLinks.js.map